import { LiveForm } from './liveform';
import { LiveFormDTO } from '../dto/liveform-dto';
import { LiveFormFactory } from '../helpers/liveform.factory';

export interface LFOfflineOrderDto {
  id: string;
  form: LiveFormDTO;
  sourceType: LFOfflineOrderSourceType;
  updatedAt: Date;
}

export class LFOfflineOrder {
  id: string;
  form: LiveForm;
  sourceType: LFOfflineOrderSourceType;
  updatedAt: Date;

  constructor(dto: LFOfflineOrderDto) {
    this.id = dto.id;
    this.form = LiveFormFactory.fromLiveFormDTO(dto.form);
    this.sourceType = dto.sourceType;
    this.updatedAt = dto.updatedAt;
  }
}

export enum LFOfflineOrderSourceType {
  'USER_SELECTED' = 0,
  'FAILED_ONLINE_SAVE'
}
